import navbarItems from './navbarItems';

class NavbarController {
  constructor(AuthService, ClientService, $state) {
    "ngInject";
    this.name = 'navbar';
    this.authService = AuthService;
    this.clientService = ClientService;
    this.state = $state;
    this.displayNavbarItems = [];
    this.navbarItems = this.deepCopyObject(navbarItems);
  }

  $onInit() {
    let userRoles = this.authService.getUserRoles();

    let cachedNavbarItems = sessionStorage.getItem("userNavbarItems")

    if (cachedNavbarItems) {
      //console.log("Showing cached nav")
      this.displayNavbarItems = JSON.parse(cachedNavbarItems)
    } else {
      //console.log("Showing new nav")
      this.displayNavbarItems = this.filterNavbarItems(this.navbarItems, userRoles)
      sessionStorage.setItem("userNavbarItems", JSON.stringify(this.displayNavbarItems))
    }

    //Get the user data from the auth service
    const firstName = this.authService.getUserFirstName();
    $('#navbar-first-name').html(firstName);
    $('#navbar-first-name-letter').html(firstName && firstName.charAt(0));
  }

  getLogoText() {
    if(window.location.hostname.startsWith("demo.")) {
      return 'DEMO';
    }

    return '';
  }

  getNavbarItems() {
    return this.displayNavbarItems;
  }

  filterNavbarItems(navbarItems, userRoles) {
    if (navbarItems === undefined)
      return undefined;
    let filteredNavbarItems = navbarItems.filter((element) => {
      let userHasRequiredRole = false;
      element.rolesRequired.forEach(role => {
        if(userRoles.find(x => x === role)) {
          userHasRequiredRole = true;
        }
      });
      return userHasRequiredRole;
    });

    filteredNavbarItems.forEach(navbarItem => {
      navbarItem.subItems = this.filterNavbarItems(navbarItem.subItems, userRoles)
    })

    return filteredNavbarItems;
  }

  logout() {
    this.authService.logout();
  }

  changePassword() {
    this.state.go("main.resetPassword")
  }

  editProfile() {
    this.state.go("main.editProfile")
  }

  deepCopyObject(object) {
    return JSON.parse(JSON.stringify(object))
  }
}

export default NavbarController;



// WEBPACK FOOTER //
// ./client/app/common/navbar/navbar.controller.js